export default "/assets/provider-badge-autocx.v1.svg";